module.exports = __webpack_public_path__ + "static/media/FoodTruck.420f0ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/FoodTruck.png
// module id = 1336
// module chunks = 3